<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
}
</script>

<style>
 #app {
   font-family: "Avenir", Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   text-align: center;
   color: #2c3e50;
 }
 .specialValue {
   font-weight: bold;
   font-style: italic;
   color: darkred;
 }
 .tableLinkIcon {
    float: right;
    background-color: rgb(14, 78, 131);
    font-size: 12px;
    padding: 3px 6px;
    border-radius: 15px;
    margin-right: 8px;
 }
 .mvpLink {
   float: right;
   background-color: rgba(46, 141, 67, 0.884);
   padding: 2px;
   border-radius: 5px;
   margin-right: 8px;
   height: 28px;
   cursor: pointer;
 }
 .menuStyle:hover {
   background-color: rgb(12, 170, 130, .3);
 }
 .titleLinkIcon {
   display: inline-block;
 }
 .tableLinkIcon a {
   color: white;
   font-weight: normal;
   text-decoration: none;
   /* font-size: 6; */
 }
 .titleLinkIcon a {
   font-weight: bold;
   text-decoration: none;
 }
 .downloadLink {
   cursor: pointer;
   color: blue;
   text-decoration: underline;
 }
 .el-divider {
   background-color: rgba(0, 0, 0, .3)
 }
 .mbodymap_m {
   font-style: italic;
   font-weight: bolder;
   color: #2F891B;
 }
 .mbodymap_body {
   /* font-style: italic;
   font-weight: bolder; */
   color: #2F891B;
 }
 .mbodymap_map {
   /* font-style: italic; */
   font-weight: bolder;
   color: #2F891B;
 }
 .specialBodysite {
   font-weight: bold;
   font-style: italic;
   color: rgba(28, 12, 73);
 }
 .specialPhenotype {
   font-weight: bold;
   font-style: italic;
   color: rgb(14, 78, 131);
 }
 .specialTaxon {
   font-weight: bold;
   font-style: italic;
   color: rgb(23, 109, 116);
 }
 b {
   color: rgba(0, 0, 0, .8);
 }
</style>



// WEBPACK FOOTER //
// src/App.vue